import React, {useState} from "react";
import {useHistory} from "react-router-dom";
import PropTypes from "prop-types";
import ChatFormGoogleAdress from "../../../../containers/Chat/ChatFormGoogleAdress";
import "react-day-picker/lib/style.css";
import "./styles.scss";
import SendButton from "../../shared/SendButton/SendButton";
import ContainerReponse from "../../Layout/ContainerReponse/ContainerReponse";
import {isNight} from "../../../../utils/isNight";

import useGoogle from "react-google-autocomplete/lib/usePlacesAutocompleteService";
import HandleFirstName from "./HandleFirstName";
import HandleLastName from "./HandleLastName";
import HandleAddress from "./HandleAddress";
import HandlePhone from "./HandlePhone";
import HandleFreeQuestion from "./HandleFreeQuestion";
import HandleCity from "./HandleCity";
import HandlePostalCode from "./handlePostalCode";

// eslint-disable-next-line react/prop-types
export const Debounce = () => {
    const {
        getPlacePredictions,
        isPlacePredictionsLoading,
    } = useGoogle({
        apiKey: process.env.REACT_APP_GOOGLE,
    });
    const [value, setValue] = useState("");
    return (
        <>
            <ChatFormGoogleAdress
                type="text"
                label="Tapez votre adresse"
                value={value}
                onChange={(evt) => {
                    getPlacePredictions({input: evt.target.value});
                    setValue(evt.target.value);
                }}
                loading={isPlacePredictionsLoading}
            >

                <SendButton/>
            </ChatFormGoogleAdress>
        </>
    );
};


const Form = ({
                  messageValue,
                  setChatBotMessageValue,
                  addMessage,
                  addBotMessage,
                  inputDisabled,
                  setInputDisable,
                  setUserInfos,
                  updateFirstname,
                  updateLastname,
                  updateAdress,
                  updateCity,
                  updateZIPCode,
                  updatePhoneNumber,
                  disableDatePicker,
                  loadingBotMessage,
                  dataUser,
                  userInfos,
                  clearChatBot,
                  createFreeQuestion
              }) => {

    const [firstname, setFirstname] = useState();
    const [step, setStep] = useState(0);
    const history = useHistory();

    const responseBotDelay = 1500;
//================ STEP 0 ===============
    const handleContinue = () => {
        setInputDisable(true);
        loadingBotMessage(true);
        setTimeout(() => {
            if (!dataUser.name || !dataUser.tel || !dataUser.firstname) {
                addBotMessage("Très bien ! Pour commencer, quel est votre prénom ?", "bot");
                loadingBotMessage(false);
                setInputDisable(false);
                setStep(0.1);
            } else {
                addBotMessage("Bien reçu merci ! Vous pouvez maintenant formuler votre question à laquelle nous répondrons dans les meilleurs délais. Veillez à être précis afin que nous puissions bien cadrer notre réponse. A très bientôt.", "bot");
                loadingBotMessage(false);
                setInputDisable(false);
                setStep(4);
            }
        }, responseBotDelay);
    };

    const handleStop = () => {
        setInputDisable(true);
        loadingBotMessage(true);
        setTimeout(() => {
            addBotMessage(`D’accord, cliquez-ici pour revenir à votre tableau de bord. Nous restons à votre disposition pour toute demande ultérieure. Si vous rencontrez des difficultés, n’hésitez pas à nous appeler au 06 05 05 05 05 ou à nous envoyer un email à support@prevandcare.com. Bonne ${isNight() ? "soirée" : "journée"}.`, "bot");
            loadingBotMessage(false);
            setInputDisable(false);
            setStep(7);
        }, responseBotDelay);
    };

    const handleChange = (e) => {
        setChatBotMessageValue(e.target.value);
    };

    return (
        <>
            { //================ Case if user does not exist in DataBase ==================
//================ MULTIPLE STEP FORM ==================
                {
                    0:
                        <ContainerReponse>
                            <ul className="choices">
                                <button onClick={handleContinue}>Oui</button>
                                <button onClick={handleStop}>Non</button>
                            </ul>
                            {/*<Button disabled={inputDisabled ? "disabled" : ""} value="Oui" color="orange" onClick={handleContinue} />*/}
                            {/*<Button disabled={inputDisabled ? "disabled" : ""} value="Non" color="orange" onClick={handleStop}/>*/}
                        </ContainerReponse>,
                    0.1:
                        <HandleFirstName
                            addMessage={addMessage}
                            addBotMessage={addBotMessage}
                            inputDisabled={inputDisabled}
                            setInputDisable={setInputDisable}
                            setUserInfos={setUserInfos}
                            updateFirstname={updateFirstname}
                            loadingBotMessage={loadingBotMessage}
                            responseBotDelay={responseBotDelay}
                            setStep={setStep}
                            setFirstname={setFirstname}
                            messageValue={messageValue}
                            handleChange={handleChange}
                        />,
                    1:
                        <HandleLastName
                            addMessage={addMessage}
                            addBotMessage={addBotMessage}
                            inputDisabled={inputDisabled}
                            setInputDisable={setInputDisable}
                            setUserInfos={setUserInfos}
                            updateLastname={updateLastname}
                            loadingBotMessage={loadingBotMessage}
                            responseBotDelay={responseBotDelay}
                            setStep={setStep}
                            messageValue={messageValue}
                            handleChange={handleChange}
                        />,
                    2:
                        <HandleAddress
                            addMessage={addMessage}
                            addBotMessage={addBotMessage}
                            inputDisabled={inputDisabled}
                            setInputDisable={setInputDisable}
                            updateAdress={updateAdress}
                            updateZIPCode={updateZIPCode}
                            updateCity={updateCity}
                            loadingBotMessage={loadingBotMessage}
                            responseBotDelay={responseBotDelay}
                            setStep={setStep}
                            messageValue={messageValue}
                            handleChange={handleChange}
                            userInfos={userInfos}
                            setUserInfos={setUserInfos}
                        />,
                    2.1:
                        <HandleCity
                            addMessage={addMessage}
                            addBotMessage={addBotMessage}
                            inputDisabled={inputDisabled}
                            setInputDisable={setInputDisable}
                            updateAdress={updateAdress}
                            updateZIPCode={updateZIPCode}
                            updateCity={updateCity}
                            loadingBotMessage={loadingBotMessage}
                            responseBotDelay={responseBotDelay}
                            setStep={setStep}
                            messageValue={messageValue}
                            handleChange={handleChange}
                            userInfos={userInfos}
                            setUserInfos={setUserInfos}
                        />
                    ,
                    2.2:
                        <HandlePostalCode
                            addMessage={addMessage}
                            addBotMessage={addBotMessage}
                            inputDisabled={inputDisabled}
                            setInputDisable={setInputDisable}
                            updateAdress={updateAdress}
                            updateZIPCode={updateZIPCode}
                            updateCity={updateCity}
                            loadingBotMessage={loadingBotMessage}
                            responseBotDelay={responseBotDelay}
                            setStep={setStep}
                            messageValue={messageValue}
                            handleChange={handleChange}
                            userInfos={userInfos}
                            setUserInfos={setUserInfos}
                        />,
                    3:
                        <HandlePhone
                            addMessage={addMessage}
                            addBotMessage={addBotMessage}
                            inputDisabled={inputDisabled}
                            setInputDisable={setInputDisable}
                            setUserInfos={setUserInfos}
                            updatePhoneNumber={updatePhoneNumber}
                            loadingBotMessage={loadingBotMessage}
                            responseBotDelay={responseBotDelay}
                            setStep={setStep}
                            messageValue={messageValue}
                            handleChange={handleChange}
                        />,
                    4:
                        <HandleFreeQuestion
                            addMessage={addMessage}
                            addBotMessage={addBotMessage}
                            inputDisabled={inputDisabled}
                            setInputDisable={setInputDisable}
                            setUserInfos={setUserInfos}
                            loadingBotMessage={loadingBotMessage}
                            responseBotDelay={responseBotDelay}
                            setStep={setStep}
                            messageValue={messageValue}
                            handleChange={handleChange}
                            disableDatePicker={disableDatePicker}
                            createFreeQuestion={createFreeQuestion}
                        />,
                    5:
                        <ContainerReponse>
                            <ul className="choices">
                                <button onClick={() => {
                                    clearChatBot();
                                    history.push("/");
                                }}>Revenir à la page des prises en charges
                                </button>
                            </ul>
                        </ContainerReponse>
                }[step]}
        </>
    );
};

Form.propTypes = {
    setChatBotMessageValue: PropTypes.func,
    messageValue: PropTypes.string,
    tel: PropTypes.string,
    inputDisabled: PropTypes.bool,
    addMessage: PropTypes.func,
    addBotMessage: PropTypes.func,
    setInputDisable: PropTypes.func,
    setUserInfos: PropTypes.func,
    setSelectedTime: PropTypes.func,
    setSelectedDay: PropTypes.func,
    selectedDay: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
    selectedTime: PropTypes.string,
    sendPlanDemand: PropTypes.func,
    updateFirstname: PropTypes.func,
    updateLastname: PropTypes.func,
    updateAdress: PropTypes.func,
    updateCity: PropTypes.func,
    updateZIPCode: PropTypes.func,
    updatePhoneNumber: PropTypes.func,
    disableDatePicker: PropTypes.func,
    loadingBotMessage: PropTypes.func,
    dataUser: PropTypes.object,
    userInfos: PropTypes.object,
    clearChatBot: PropTypes.func,
    createFreeQuestion: PropTypes.func,
};

export default Form;